import type { BoxFileItem, BoxFolderPathCount } from '@savvy/constants/generated/gql-types';

export const SIDEBAR_WIDTH = 356;
export const TOP_BAR_HEIGHT = 60;

export type BoxFileWithThumbnail = {
  boxFile: BoxFileItem;
  thumbnailBase64: string | null;
};

export function computeAllEntryCount(pathCounts: BoxFolderPathCount[] | null | undefined): number {
  return (
    pathCounts?.reduce((total, entry) => {
      // FIXME: probably should figure out a better way to delineate group and advisor files other than these strings
      if (entry.path === '' || entry.path === '/My assets' || entry.path === "/My team's assets") {
        return total + (entry.count || 0);
      }
      return total;
    }, 0) || 0
  );
}

export const formatFileName = (filename: string): string => {
  const lastDotIdx = filename.lastIndexOf('.');
  const nameWithoutExtension = lastDotIdx !== -1 ? filename.substring(0, lastDotIdx) : filename;
  return nameWithoutExtension.replaceAll('-', ' ');
};

// change a string into sentence case
// eg: input = "This Is My Sentence" -> This is my sentence
export const toSentenceCase = (input: string, delimiter: string): string => {
  return input
    .split(delimiter)
    .map((word: string, index: number) => (index !== 0 ? word.toLowerCase() : word))
    .join(' ');
};

// use to format a path from pathCounts
// eg: input =  "/My Assets/My Category/My Test" -> My assets - My category - My test
export const formatPath = (input: string): string => {
  return input
    .slice(1) // inputPaths start with "/"
    .split('/')
    .map((folderName: string) => toSentenceCase(folderName, ' '))
    .join(' - ');
};
